(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-addon-guard"] && !Shopify.designMode) return;
  try {
    // cart-addon-guard — clamp add-on qty to 1; remove orphaned add-ons.
  (function () {
    if (window.__sbCartGuard) return;
    window.__sbCartGuard = true;

    var ADDON_SKUS = ['EXSHIP', 'INSTRUMENTALSONG'];
    var busy = false;

    function root() {
      return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    }

    function swap(destSelector, html, srcSelector) {
      if (!html) return;
      var dest = document.querySelector(destSelector);
      var src = new DOMParser().parseFromString(html, 'text/html').querySelector(srcSelector);
      if (dest && src) dest.innerHTML = src.innerHTML;
    }

    function showNote(text) {
      var host = document.querySelector('cart-drawer .drawer__contents') || document.querySelector('#main-cart-items .js-contents');
      if (!host || host.querySelector('.cart-guard-note')) return;
      var p = document.createElement('p');
      p.className = 'cart-guard-note';
      p.setAttribute('role', 'status');
      p.textContent = text;
      host.insertBefore(p, host.firstChild);
    }

    function rerender(res, orphaned) {
      var drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.renderContents === 'function') {
        drawer.renderContents(res);
      } else if (res.sections) {
        swap('#main-cart-items .js-contents', res.sections['main-cart-items'], '.js-contents');
        swap('#main-cart-footer .js-contents', res.sections['main-cart-footer'], '.js-contents');
        var bubble = document.getElementById('cart-icon-bubble');
        if (bubble && res.sections['cart-icon-bubble']) {
          var nb = new DOMParser().parseFromString(res.sections['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
          if (nb) bubble.innerHTML = nb.innerHTML;
        }
      }
      if (orphaned) showNote('Add-ons removed — they apply to a song in your cart.');
    }

    function run() {
      if (busy) return;
      fetch(root() + 'cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          if (!cart || !cart.items) return;
          var hasParent = cart.items.some(function (i) { return ADDON_SKUS.indexOf(i.sku) === -1; });
          var updates = {};
          var changed = false;
          var orphaned = false;
          cart.items.forEach(function (i) {
            if (ADDON_SKUS.indexOf(i.sku) === -1) return;
            var want = hasParent ? Math.min(i.quantity, 1) : 0;
            if (want !== i.quantity) {
              updates[i.variant_id] = want;
              changed = true;
              if (want === 0) orphaned = true;
            }
          });
          if (!changed) return;

          var drawer = document.querySelector('cart-drawer');
          var sections;
          if (drawer && typeof drawer.getSectionsToRender === 'function') {
            sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
          } else {
            sections = ['main-cart-items', 'main-cart-footer', 'cart-icon-bubble'];
          }

          busy = true;
          return fetch(root() + 'cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ updates: updates, sections: sections, sections_url: window.location.pathname }),
          })
            .then(function (r) { return r.json(); })
            .then(function (res) { if (res && !res.status) rerender(res, orphaned); })
            .catch(function () {})
            .then(function () { busy = false; });
        })
        .catch(function () {});
    }

    if (document.readyState !== 'loading') run();
    else document.addEventListener('DOMContentLoaded', run);

    // Dawn publishes cart updates through its pubsub — react to song removals etc.
    if (typeof window.subscribe === 'function' && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
      window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, function () { setTimeout(run, 50); });
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cart-addon-upsell"] && !Shopify.designMode) return;
  try {
    // cart-addon-upsell — add an add-on without leaving the cart, then refresh in place.
  (function () {
    if (window.__sbCartUpsell) return;
    window.__sbCartUpsell = true;

    function root() {
      return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    }

    function swap(destSelector, html, srcSelector) {
      if (!html) return;
      var dest = document.querySelector(destSelector);
      var src = new DOMParser().parseFromString(html, 'text/html').querySelector(srcSelector);
      if (dest && src) dest.innerHTML = src.innerHTML;
    }

    function addAddon(id, btn) {
      var drawer = document.querySelector('cart-drawer');
      var onPage = document.getElementById('main-cart-items');
      var sections;
      if (drawer && typeof drawer.getSectionsToRender === 'function') {
        sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
      } else {
        sections = ['main-cart-items', 'main-cart-footer', 'cart-icon-bubble'];
      }

      var body = {
        items: [{ id: id, quantity: 1 }],
        sections: sections,
        sections_url: window.location.pathname,
      };

      fetch(root() + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body),
      })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (!res || res.status) return; // 422 etc.
          if (drawer && typeof drawer.renderContents === 'function') {
            drawer.renderContents(res);
          } else if (onPage && res.sections) {
            swap('#main-cart-items .js-contents', res.sections['main-cart-items'], '.js-contents');
            swap('#main-cart-footer .js-contents', res.sections['main-cart-footer'], '.js-contents');
            var bubble = document.getElementById('cart-icon-bubble');
            if (bubble && res.sections['cart-icon-bubble']) {
              var newBubble = new DOMParser()
                .parseFromString(res.sections['cart-icon-bubble'], 'text/html')
                .querySelector('.shopify-section');
              if (newBubble) bubble.innerHTML = newBubble.innerHTML;
            }
          }
        })
        .catch(function () {})
        .then(function () { if (btn) btn.removeAttribute('aria-busy'); });
    }

    document.addEventListener('click', function (e) {
      var btn = e.target && e.target.closest ? e.target.closest('.cart-upsell__add') : null;
      if (!btn) return;
      e.preventDefault();
      var id = btn.getAttribute('data-variant-id');
      if (!id || btn.getAttribute('aria-busy') === 'true') return;
      btn.setAttribute('aria-busy', 'true');
      addAddon(id, btn);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["song-brief"] && !Shopify.designMode) return;
  try {
    // song-brief — one behavior for every .sb-brief on the page. Idempotent.
  // Adaptive prompts + context pre-fill + voice (attach/record); exposes an API
  // (validate/collect/getVoice) on each [data-song-brief] root for the host's
  // add-to-cart. No pricing or cart logic lives here.
  (function () {
    if (window.__sbBriefInit) return;
    window.__sbBriefInit = true;

    var REL = {
      partner:{memory:"the night we met at Dani’s party",like:"goofy, kind, always cold",detail:"our spot — the corner booth at Joe’s",mean:"my person, my calm"},
      spouse:{memory:"our first dance at the lake house",like:"stubborn, generous, terrible at cards",detail:"we say ‘see ya, see ya bye’",mean:"25 years — still my best friend"},
      parent:{memory:"Sunday pancakes, her humming in the kitchen",like:"fierce, funny, never sits still",detail:"always says ‘OMG’",mean:"she raised me twice"},
      child:{memory:"the day she was born — tiny and loud",like:"curious, brave, obsessed with dinosaurs",detail:"we call him Bug",mean:"my whole heart"},
      friend:{memory:"that road trip we still laugh about",like:"loyal, blunt, the planner",detail:"inside joke: ‘the goose incident’",mean:"my ride-or-die for 15 years"},
      pet:{memory:"the day we brought her home from the shelter",like:"steals socks, naps in sunbeams",detail:"we call her Bean",mean:"got me through a hard year"},
      memorial:{memory:"long porch talks, his old guitar",like:"gentle, stubborn, always singing",detail:"signed every note ‘love, Pop’",mean:"the man who taught me everything"},
      other:{memory:"a moment that says who they are",like:"their quirks — what they always do",detail:"a nickname or inside joke",mean:"why they matter to you"}
    };
    var QMAP = {
      spouse:["How did you two meet?","What do you love most about them?","An inside joke or detail only you two share","What they mean to you — and why now"],
      partner:["How did you two meet?","What do you love most about them?","An inside joke or detail only you two share","What they mean to you — and why now"],
      parent:["A memory that says who they are","What did they always say or do?","Something they taught you, or a family saying","What they mean to you — and why now"],
      child:["A moment with them you’ll never forget","What are they like? (their quirks)","A nickname, or something only your family knows","Your hopes for them — and why this song now"],
      friend:["How did you become friends?","What makes them a great friend?","An inside joke or a story you both retell","What their friendship means to you"],
      pet:["How did they come into your life?","What are they like? (their funny habits)","What you call them, or a quirk only you’d know","What they mean to you — and why now"],
      memorial:["A memory that captures who they were","What were they like?","Something they always said or did","What they meant to you — and what you miss most"],
      other:["A favorite memory with them","What are they like?","A nickname, inside joke, or detail only you’d know","What they mean to you — and why now"]
    };
    // occasion → optional milestone field + a sensible default relationship
    var OCC = {
      anniversary:{rel:"spouse", ms:{label:"Which anniversary?", type:"select", opts:["Choose…","1st (paper)","5th (wood)","10th (tin)","25th (silver)","40th (ruby)","50th (gold)","Another year"]}},
      birthday:{rel:"friend"},
      wedding:{rel:"spouse", ms:{label:"Wedding date", type:"date"}},
      retirement:{rel:"parent", ms:{label:"Years of service (or what they’re retiring from)", type:"text", ph:"e.g., 30 years at the fire dept"}},
      graduation:{rel:"child", ms:{label:"What are they graduating from?", type:"text", ph:"e.g., high school, nursing school"}},
      "valentine's day":{rel:"partner"}, "mother's day":{rel:"parent"}, "father's day":{rel:"parent"},
      memorial:{rel:"memorial"}, christmas:{rel:"friend"}, "thank you":{rel:"friend"},
      "just because":{rel:"partner"}, other:{rel:"other"}
    };
    // mood follows the relationship (overridable by the visitor)
    var MOOD = { spouse:"romantic", partner:"romantic", parent:"nostalgic", child:"happy", friend:"upbeat", pet:"happy", memorial:"emotional", other:"emotional" };

    // Angle-PDP intent sets — recipient label + 4 story prompts (+ placeholders) +
    // optional story-section subtitle. Selected per product via data-form-intent (a
    // product metafield custom.form_intent). data-form-prompts (metafield
    // custom.form_prompts, newline-separated) can override the prompt LABELS free-form.
    // When neither attribute is present the relationship-adaptive defaults above run
    // unchanged, so every non-angle page (custom-song, occasion modals, plaque) is
    // untouched. Pride angles keep using pride MODE (data-pride), not an intent set.
    var FORM_INTENTS = {
      "drive-safe":{
        recipient:"Who's heading out the door?",
        sub:"Tell us about them and the goodbye you always say — we'll build the song around it.",
        prompts:["Who are they to you, and where are they driving off to?","What do you always say before they leave?","A memory from the driveway, the porch, the goodbye","What you want them to feel every time it plays"],
        phs:["my granddaughter, leaving for college in Ohio","text me when you get home","she still beeps twice pulling out of the drive","that home is always right behind them"],
        hide:["occasion","mood"], occasion:"Drive Safe", mood:"nostalgic"
      },
      "memorial":{
        recipient:"Who are we remembering?",
        sub:"Tell us about them — a few words for each is enough, or leave a voice note.",
        prompts:["A memory that captures who they were","What were they like?","Something they always said or did","What they meant to you — and what you miss most"],
        phs:["long porch talks, his old guitar","gentle, stubborn, always singing","signed every note 'love, Pop'","the man who taught me everything"]
      },
      "kids-birthday":{
        recipient:"Whose birthday is it?",
        sub:"Tell us about the birthday kid — a few words for each is enough.",
        prompts:["How old are they turning, and what are they into right now?","A moment with them you'll never forget","What are they like? (their quirks)","What you want them to feel on their day"],
        phs:["turning 7, obsessed with dinosaurs","the day she learned to ride her bike","fearless, silly, terrible at hiding","how loved they are"],
        hide:["occasion","mood"], occasion:"Birthday", mood:"happy"
      },
      "apology":{
        recipient:"Who are you apologizing to?",
        sub:"Tell us who you hurt and what you wish you'd said — a few words for each is enough, or leave a voice note.",
        prompts:["Who are you saying sorry to, and what are they to you?","What happened — what are you sorry for?","What do they mean to you, in your words?","How do you want to make it right?"],
        phs:["my wife Sarah — my best friend of 20 years","I put work first and kept letting her down","she's the calm in every storm I've caused","show her I've changed, not just say it"],
        hide:["occasion","mood"], occasion:"Apology", mood:"emotional"
      }
    };

    function val(el) { return el ? (el.value || '').trim() : ''; }
    function urlp(k) { try { return new URLSearchParams(window.location.search).get(k) || ''; } catch (e) { return ''; } }
    function setSel(sel, v) { if (!sel || !v) return false; v = String(v).toLowerCase(); for (var i = 0; i < sel.options.length; i++) { if (sel.options[i].value.toLowerCase() === v) { sel.selectedIndex = i; return true; } } return false; }

    function wire(root) {
      if (root.__sbWired) return;
      root.__sbWired = true;

      var rel = root.querySelector('[data-rel]');
      var occ = root.querySelector('[data-occ]');
      var msWrap = root.querySelector('[data-milestone-wrap]');
      var msLabel = root.querySelector('[data-milestone-label]');
      var msControl = root.querySelector('[data-milestone-control]');
      var moodSel = root.querySelector('[data-k="Song Mood"]');
      var userSetMood = false;
      setSel(rel, (root.getAttribute('data-ctx-rel') || '') || urlp('relationship') || urlp('rel'));
      setSel(occ, (root.getAttribute('data-ctx-occ') || '') || urlp('occasion') || urlp('occ'));

      // Angle-PDP intent: a named set (data-form-intent) and/or a free-form prompt
      // override (data-form-prompts, "|"-separated). Both absent → customPrompts is
      // null and applyRel behaves exactly as before.
      var intentKey = (root.getAttribute('data-form-intent') || '').toLowerCase();
      var intent = FORM_INTENTS[intentKey] || null;
      var promptsAttr = root.getAttribute('data-form-prompts') || '';
      var customPrompts = promptsAttr ? promptsAttr.split('|') : (intent ? intent.prompts : null);
      var intentPhs = intent ? intent.phs : null;
      if (intent) {
        var recIn = root.querySelector('[data-k="Recipient Name"]');
        var recLabel = recIn ? root.querySelector('label[for="' + recIn.id + '"]') : null;
        if (recLabel && intent.recipient) recLabel.innerHTML = intent.recipient + '<span class="sb-brief__req" aria-hidden="true">*</span>';
        var subEl = root.querySelector('.sb-brief__cardsub');
        if (subEl && intent.sub) subEl.textContent = intent.sub;
      }

      // Per-intent field visibility. data-form-hide (metafield custom.form_hide,
      // comma-separated) overrides the intent's hide list. Hidden fields still
      // submit sensible defaults so fulfillment loses no data. Absent → nothing
      // hidden → today's full field set.
      var hideAttr = (root.getAttribute('data-form-hide') || '').toLowerCase();
      var hideSet = hideAttr ? hideAttr.split(',') : (intent && intent.hide ? intent.hide : null);
      if (hideSet) {
        var hideWrap = function (el, sel) {
          var w = el && el.closest(sel || '.sb-brief__field'); if (!w) return; w.style.display = 'none';
          var row = w.closest('.sb-brief__two');
          if (row) { var shown = 0; row.querySelectorAll('.sb-brief__field').forEach(function (f) { if (f.style.display !== 'none') shown++; }); if (shown <= 1) row.style.gridTemplateColumns = '1fr'; }
        };
        hideSet.forEach(function (raw) {
          var key = (raw || '').trim();
          if (key === 'occasion') {
            hideWrap(occ);
            if (msWrap) msWrap.hidden = true;
            var occVal = (intent && intent.occasion) || (root.getAttribute('data-ctx-occ') || '');
            if (occ) occ.removeAttribute('data-k');
            if (occVal) { var oi = document.createElement('input'); oi.type = 'hidden'; oi.setAttribute('data-k', 'Occasion'); oi.value = occVal; root.appendChild(oi); }
          } else if (key === 'milestone') {
            if (msWrap) msWrap.hidden = true;
          } else if (key === 'mood') {
            hideWrap(moodSel);
            if (moodSel && intent && intent.mood) setSel(moodSel, intent.mood);
            userSetMood = true;
          } else if (key === 'relationship') {
            hideWrap(rel);
          } else if (key === 'style') {
            hideWrap(root.querySelector('[data-k="Music Style"]'));
          } else if (key === 'voice') {
            hideWrap(root.querySelector('[data-k="Singer Preference"]'));
          } else if (key === 'mentions') {
            hideWrap(root.querySelector('[data-k="Special Mentions"]'), '.sb-brief__prompt');
          } else if (key === 'voicenote') {
            var vn = root.querySelector('[data-voice]'); if (vn) vn.style.display = 'none';
          }
        });
      }

      function applyRel() {
        var r = rel ? rel.value : 'other', qs = customPrompts || QMAP[r] || QMAP.other;
        root.querySelectorAll('.sb-brief__pl[data-q]').forEach(function (l) { var s = parseInt(l.getAttribute('data-q'), 10); if (qs[s]) l.textContent = qs[s]; });
        if (customPrompts) {
          root.querySelectorAll('.sb-brief__pin[data-slot]').forEach(function (i) { var s = parseInt(i.getAttribute('data-slot'), 10); i.setAttribute('placeholder', (intentPhs && intentPhs[s]) ? intentPhs[s] : ''); });
        } else {
          var ex = REL[r] || REL.other;
          root.querySelectorAll('[data-ex]').forEach(function (i) { var k = i.getAttribute('data-ex'); if (ex[k] !== undefined) i.setAttribute('placeholder', ex[k]); });
        }
        var moodPick = MOOD[r];
        if (occ && (occ.value || '').toLowerCase() === 'memorial') { moodPick = 'emotional'; }
        if (moodSel && !userSetMood && moodPick) { setSel(moodSel, moodPick); }
      }
      var sbbPride = root.getAttribute('data-pride') === '1';

      function buildMilestone() {
        if (!msWrap) return;
        var cfg = OCC[(occ && occ.value ? occ.value : '').toLowerCase()];
        if (!cfg || !cfg.ms) { msWrap.hidden = true; if (msControl) msControl.innerHTML = ''; return; }
        msWrap.hidden = false;
        if (msLabel) msLabel.textContent = cfg.ms.label;
        var fid = (msLabel && msLabel.getAttribute('for')) || (root.id + '-ms');
        var html;
        if (cfg.ms.type === 'select') {
          html = '<select class="sb-brief__sel sb-brief__sel--ms" id="' + fid + '" data-k="Milestone">';
          cfg.ms.opts.forEach(function (o, i) { html += '<option value="' + (i === 0 ? '' : o) + '">' + o + '</option>'; });
          html += '</select>';
        } else if (cfg.ms.type === 'date') {
          html = '<input class="sb-brief__in" id="' + fid + '" type="date" data-k="Milestone">';
        } else {
          html = '<input class="sb-brief__in" id="' + fid + '" type="text" data-k="Milestone" placeholder="' + (cfg.ms.ph || '') + '">';
        }
        if (msControl) msControl.innerHTML = html;
      }

      if (!sbbPride) {
        var userSetRel = false;
        if (rel) { rel.addEventListener('change', function () { userSetRel = true; applyRel(); }); }
        if (moodSel) { moodSel.addEventListener('change', function () { userSetMood = true; }); }
        if (occ) { occ.addEventListener('change', function () {
          buildMilestone();
          if (!userSetRel) { var cfg = OCC[(occ.value || '').toLowerCase()]; if (cfg && cfg.rel) { setSel(rel, cfg.rel); } }
          applyRel();
        }); }
        buildMilestone();
        applyRel();
      }

      // voice: attach + record
      var voiceBlob = null, voiceName = null;
      var vfile = root.querySelector('[data-vfile]'), vstatus = root.querySelector('[data-vstatus]');
      var vbox = root.querySelector('[data-voice]'), vrec = root.querySelector('[data-vrec]');
      function setStatus(txt, cls) { if (!vstatus) return; vstatus.textContent = txt; vstatus.className = 'sb-brief__vstatus' + (cls ? ' ' + cls : ''); }
      if (vfile) vfile.addEventListener('change', function () { if (vfile.files && vfile.files[0]) { voiceBlob = vfile.files[0]; voiceName = vfile.files[0].name; setStatus('✓ Attached: ' + voiceName, 'is-on'); } });
      var canRec = !!(navigator.mediaDevices && navigator.mediaDevices.getUserMedia && window.MediaRecorder);
      if (vrec && canRec) {
        vrec.hidden = false;
        var mr = null, chunks = [], recState = 'idle', secs = 0, timer = null, stream = null;
        var recLabel = root.querySelector('[data-vrec-label]');
        function fmt(s) { return Math.floor(s / 60) + ':' + (s % 60 < 10 ? '0' : '') + (s % 60); }
        vrec.addEventListener('click', function () {
          if (recState === 'idle') {
            navigator.mediaDevices.getUserMedia({ audio: true }).then(function (s) {
              stream = s; chunks = []; mr = new MediaRecorder(s);
              mr.ondataavailable = function (e) { if (e.data && e.data.size) chunks.push(e.data); };
              mr.onstop = function () { voiceBlob = new Blob(chunks, { type: (mr.mimeType || 'audio/webm') }); voiceName = 'voice-note.webm'; if (stream) { stream.getTracks().forEach(function (t) { t.stop(); }); } setStatus('✓ Voice note recorded · ' + fmt(secs), 'is-on'); };
              mr.start(); recState = 'rec'; secs = 0; vbox.setAttribute('data-state', 'rec'); if (recLabel) recLabel.textContent = 'Stop'; setStatus('● Recording 0:00', 'is-rec');
              timer = setInterval(function () { secs++; setStatus('● Recording ' + fmt(secs), 'is-rec'); }, 1000);
            }).catch(function () { setStatus('Mic unavailable — attach a file instead', ''); });
          } else if (recState === 'rec') {
            recState = 'idle'; if (timer) clearInterval(timer); vbox.setAttribute('data-state', 'idle'); if (recLabel) recLabel.textContent = 'Re-record'; try { mr.stop(); } catch (e) {}
          }
        });
      }

      // API for the host's add-to-cart
      root.sbBrief = {
        validate: function () {
          var name = root.querySelector('[data-k="Recipient Name"]');
          if (!val(name)) { if (name) { try { name.focus(); } catch (e) {} } return 'Please add who the song is for.'; }
          var hasStory = false, firstEmpty = null;
          root.querySelectorAll('[data-slot]').forEach(function (i) { if (val(i)) hasStory = true; else if (!firstEmpty) firstEmpty = i; });
          if (!hasStory && !voiceBlob) { if (firstEmpty) { try { firstEmpty.focus(); } catch (e) {} } return 'Tell us a little of your story, or add a voice note.'; }
          return '';
        },
        collect: function () {
          var props = {};
          root.querySelectorAll('[data-k]').forEach(function (i) { var v = val(i); if (v) props[i.getAttribute('data-k')] = v; });
          var storyParts = [];
          root.querySelectorAll('[data-slot]').forEach(function (i) {
            var v = val(i);
            if (v) { var lbl = root.querySelector('.sb-brief__pl[data-q="' + i.getAttribute('data-slot') + '"]'); storyParts.push((lbl ? lbl.textContent : 'Story') + ': ' + v); }
          });
          if (storyParts.length) props['Story Details'] = storyParts.join('\n');
          return props;
        },
        getVoice: function () { return voiceBlob ? { blob: voiceBlob, name: voiceName || 'voice-note.webm' } : null; }
      };
    }

    function initAll() { document.querySelectorAll('[data-song-brief]').forEach(wire); }
    if (document.readyState !== 'loading') initAll();
    else document.addEventListener('DOMContentLoaded', initAll);
    window.sbBriefInit = initAll;
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["song-player"] && !Shopify.designMode) return;
  try {
    // song-player — one behavior for every .sb-player on the page.
  // Real <audio> play/pause/seek/keyboard; progress painted by setting --p on the
  // track (its background gradient does the rest). Idempotent: safe to call again
  // (window.sbPlayerInit) for late/AJAX-injected players.
  (function () {
    if (window.__sbPlayerInit) return;
    window.__sbPlayerInit = true;

    function fmt(s) {
      s = Math.max(0, Math.floor(s || 0));
      var m = Math.floor(s / 60), ss = s % 60;
      return m + ':' + (ss < 10 ? '0' : '') + ss;
    }
    function clamp(v, lo, hi) { return Math.max(lo, Math.min(hi, v)); }

    function wire(root) {
      if (root.__sbWired) return;
      root.__sbWired = true;

      var audio = root.querySelector('.sb-player__audio');
      var btn = root.querySelector('.sb-player__play');
      var track = root.querySelector('.sb-player__track');
      var cur = root.querySelector('.sb-player__cur');
      var dur = root.querySelector('.sb-player__dur');
      if (!audio || !track) return;
      var title = root.getAttribute('data-title') || 'song';

      function paint(p) {
        p = clamp(p, 0, 1);
        track.style.setProperty('--p', (p * 100).toFixed(2) + '%');
        track.setAttribute('aria-valuenow', String(Math.round(p * 100)));
      }

      if (btn) {
        btn.addEventListener('click', function () {
          if (audio.paused) {
            document.querySelectorAll('.sb-player__audio').forEach(function (o) { if (o !== audio) o.pause(); });
            audio.play().catch(function () { /* swallow autoplay rejections */ });
          } else {
            audio.pause();
          }
        });
      }

      audio.addEventListener('play', function () {
        root.setAttribute('data-playing', '');
        if (btn) btn.setAttribute('aria-label', 'Pause ' + title);
      });
      audio.addEventListener('pause', function () {
        root.removeAttribute('data-playing');
        if (btn) btn.setAttribute('aria-label', 'Play ' + title);
      });
      audio.addEventListener('ended', function () {
        root.removeAttribute('data-playing');
        paint(0);
        if (cur) cur.textContent = '0:00';
      });
      audio.addEventListener('loadedmetadata', function () {
        if (dur && isFinite(audio.duration)) dur.textContent = fmt(audio.duration);
      });
      audio.addEventListener('timeupdate', function () {
        var d = audio.duration || 0;
        paint(d > 0 ? audio.currentTime / d : 0);
        if (cur) cur.textContent = fmt(audio.currentTime);
      });

      function seekX(clientX) {
        var r = track.getBoundingClientRect();
        var f = clamp((clientX - r.left) / r.width, 0, 1);
        if (isFinite(audio.duration) && audio.duration > 0) {
          audio.currentTime = f * audio.duration;
          paint(f);
          if (cur) cur.textContent = fmt(audio.currentTime);
        }
      }
      var dragging = false;
      track.addEventListener('pointerdown', function (e) {
        dragging = true;
        try { track.setPointerCapture(e.pointerId); } catch (err) {}
        seekX(e.clientX);
      });
      track.addEventListener('pointermove', function (e) { if (dragging) seekX(e.clientX); });
      track.addEventListener('pointerup', function () { dragging = false; });
      track.addEventListener('pointercancel', function () { dragging = false; });
      track.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') {
          e.preventDefault();
          if (isFinite(audio.duration)) audio.currentTime = clamp(audio.currentTime + 5, 0, audio.duration);
        } else if (e.key === 'ArrowLeft') {
          e.preventDefault();
          if (isFinite(audio.duration)) audio.currentTime = clamp(audio.currentTime - 5, 0, audio.duration);
        } else if (e.key === ' ' || e.key === 'Enter') {
          e.preventDefault();
          if (btn) btn.click();
        }
      });

      paint(0);
    }

    function initAll() {
      var nodes = document.querySelectorAll('.sb-player');
      for (var i = 0; i < nodes.length; i++) wire(nodes[i]);
    }

    if (document.readyState !== 'loading') initAll();
    else document.addEventListener('DOMContentLoaded', initAll);
    window.sbPlayerInit = initAll;
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["song-quiz"] && !Shopify.designMode) return;
  try {
    // song-quiz — quiz2 port (see snippet header). Idempotent; exposes the same
  // sbBrief API as song-brief so the host section's add-to-cart is untouched.
  (function () {
    if (window.__sbQuizInit) return;
    window.__sbQuizInit = true;

    // ---- quiz2.ts data mirror (sync with songbond_app lib/preview/quiz2.ts) ----
    var REL_ALL = ["Husband","Wife","Partner","Boyfriend","Girlfriend","Mom","Dad","Son","Daughter","Grandma","Grandpa","Friend","Grandson","Granddaughter","Sibling","Grandparent","Fiancé","Myself","Someone else"];
    var GENDER = { Wife:"female", Girlfriend:"female", Mom:"female", Daughter:"female", Grandma:"female", Granddaughter:"female", Husband:"male", Boyfriend:"male", Dad:"male", Son:"male", Grandpa:"male", Grandson:"male", Myself:"self" };
    var SPOUSE = ["Husband","Wife","Partner","Boyfriend","Girlfriend","Fiancé"];
    var PARENT = ["Mom","Dad"];
    var GRAND = ["Grandma","Grandpa","Grandparent"];
    var KID = ["Son","Daughter","Grandson","Granddaughter"];
    function has(a, v) { return a.indexOf(v) !== -1; }
    function genderFor(r) { return GENDER[r] || "neutral"; }
    function herHim(r) { var g = genderFor(r); return g === "female" ? "her" : g === "male" ? "him" : "them"; }

    function callNameConfig(rel) {
      var fixed = {
        Grandma: { title:"What do you call her?", sub:"Use what you’d naturally say to her.", quick:["Grandma","Nana","Grammy","Gran","Nonna"], ph:"Or type your own" },
        Grandpa: { title:"What do you call him?", sub:"Use what you’d naturally say to him.", quick:["Grandpa","Papa","Grandad","Pops","Pop-Pop"], ph:"Or type your own" },
        Mom: { title:"What do you call her?", sub:"Use what belongs in the song.", quick:["Mom","Mum","Mama","Mommy"], ph:"Or type your own" },
        Dad: { title:"What do you call him?", sub:"Use what belongs in the song.", quick:["Dad","Daddy","Papa","Pops"], ph:"Or type your own" }
      };
      if (fixed[rel]) return fixed[rel];
      if (has(SPOUSE, rel)) return { title:"What do you call " + herHim(rel) + "?", sub:"Usually a first name works best. A nickname is fine too.", quick:[], ph:"e.g. Claire, Em, Babe" };
      if (has(KID, rel)) { var g = genderFor(rel), poss = g === "female" ? "her" : g === "male" ? "his" : "their";
        return { title:"What’s " + poss + " name?", sub:"Use the name you naturally say to " + herHim(rel) + ".", quick:[], ph:"e.g. Emma" }; }
      if (rel === "Friend") return { title:"What do you call them?", sub:"First name or nickname — whatever feels natural.", quick:[], ph:"e.g. Jess, JJ" };
      if (rel === "Sibling") return { title:"What do you call them?", sub:"The name or nickname that belongs in the song.", quick:[], ph:"e.g. Jake, Sis" };
      if (rel === "Myself") return { title:"What should the song call you?", sub:"The name or nickname that feels most like you.", quick:[], ph:"e.g. Alex, AJ" };
      return { title:"What should the song call them?", sub:"Name, nickname or title — whatever feels natural.", quick:[], ph:"e.g. Coach, Uncle Rob, Sarah" };
    }
    function familyAlternatives(rel) {
      if (rel === "Grandma") return ["Grandma","Nana","Grammy","Gran"];
      if (rel === "Grandpa") return ["Grandpa","Papa","Grandad","Pops"];
      if (rel === "Mom") return ["Mom","Mum","Mama"];
      if (rel === "Dad") return ["Dad","Papa","Pops"];
      return [];
    }
    var FAMILY_WORDS = ["mom","mum","mama","mommy","dad","daddy","papa","pops","grandma","grandpa","nana","grammy","gran","grandad","pop-pop","nonna"];
    function looksLikeFirstName(v) {
      var x = v.trim().toLowerCase();
      if (!x) return false;
      return /^[a-z][a-z'-]{2,}$/.test(x) && FAMILY_WORDS.indexOf(x) === -1;
    }

    var ALL_OCCASIONS = ["Just Because","I Love You","Birthday","Anniversary","Missing You","Thank You","Apology","Wedding","Friendship","In Memory","Milestone","Proposal","Retirement","Graduation"];
    var OCC_OTHER = "Something else…";
    function occasionOrder(rel) {
      if (has(SPOUSE, rel)) return ["Anniversary","Birthday","I Love You","Just Because","Wedding","Proposal"];
      if (has(PARENT, rel)) return ["Birthday","Thank You","Just Because","In Memory","Milestone","Retirement"];
      if (has(GRAND, rel)) return ["Birthday","Thank You","Just Because","In Memory","Milestone"];
      if (has(KID, rel)) return ["Birthday","Graduation","Milestone","Just Because","Wedding"];
      if (rel === "Friend" || rel === "Sibling") return ["Birthday","Friendship","Thank You","Just Because","Milestone"];
      if (rel === "Myself") return ["Just Because","Milestone","Birthday","Graduation","Retirement"];
      return ["Birthday","Anniversary","Thank You","Just Because","Milestone"];
    }

    var ALL_STYLES = ["Gospel","Country","Acoustic","Pop","R&B","Rock","Jazz","Folk","Blues","Soul"];
    var SURPRISE = "Surprise Me";
    var VOICES = ["Female voice","Male voice","Surprise Me"];
    function recommendedStyles(rel, occ) {
      if (occ === "In Memory") return ["Gospel","Acoustic","Soul","Country"];
      if (has(PARENT, rel) || has(GRAND, rel)) return ["Gospel","Country","Acoustic","Soul"];
      if (has(SPOUSE, rel)) return ["Country","Acoustic","Pop","R&B"];
      return ["Pop","Acoustic","Country","Soul"];
    }
    function moodOptions(rel, occ) {
      if (occ === "In Memory") return ["Peaceful","Reflective","Hopeful","Sentimental"];
      if (has(SPOUSE, rel)) return ["Romantic","Heartfelt","Joyful","Playful","Sentimental"];
      if (has(KID, rel)) return ["Heartfelt","Joyful","Uplifting","Playful"];
      return ["Heartfelt","Joyful","Sentimental","Uplifting","Reflective"];
    }

    var TRAITS = {
      ROMANTIC:["Loving","Kind","My best friend","Makes me laugh","Patient","Generous","Strong","Always there","Thoughtful","Gentle","Honest","Supportive","Warm","My safe place","Stubborn","Terrible dancer","Always cold","Fixes everything","Never lets me win","Cries at films","Can't sit still","Best hugs","Sings in the car","Steals the covers","Always hungry","Makes the coffee","Never on time","Overpacks","Talks to the dog","Terrible at lying","Plans everything","Hopeless romantic","Still holds my hand","Bad at surprises","Snores","Remembers it all"],
      PARENT:["Loving","Selfless","Kind","Hardworking","Always there","Strong","Generous","Wise","Patient","Proud of me","Gentle","Forgiving","My biggest fan","Devoted","Fed everyone","Never sat down","Worried out loud","Stubborn","Sang while cooking","Bad jokes","Always early","Kept my drawings","Gave up everything","Fixed everything","Waited up","Asked for nothing","Made it from scratch","Drove me everywhere","Cried at everything","Lists for everything","Danced in the kitchen","Called to check","Same advice twice","Sunday roast","Never complained","Always busy"],
      GRAND:["Loving","Kind","Wise","Generous","Gentle","Full of stories","Family's heart","Proud of me","Patient","Devoted","Warm","Never judged","Steady","Comforting","Same story twice","Always had sweets","Fixed everything","Sang the old songs","So stubborn","Fed everyone twice","Always gardening","Called every Sunday","Kept everything","Kept every photo","Sharp as a tack","Wicked humour","Never sat still","Same old coat","Slipped me money","Knew everyone","Best roast dinner","Wrote real letters","Danced at weddings","Whistled always","Their own chair","Sweets in the pocket"],
      KID:["Kind","Funny","Brave","Clever","Loving","Full of joy","Gentle","Determined","Curious","Generous","Thoughtful","Bright","Caring","Big heart","Never stops talking","Asks why forever","Dances everywhere","Stubborn","Big feelings","Friends with all","Bad at losing","An old soul","Fearless","Collects everything","Draws on walls","Sings made-up songs","Hates bedtime","Loves animals","Tells long stories","Copies everything","Always muddy","Runs everywhere","Wants to help","Laughs at nothing","Never still","Asks for one more"],
      SIBLING:["My best friend","Funny","Loyal","Kind","Has my back","Generous","Strong","Talented","Thoughtful","Protective","Honest","Fun","Supportive","My first call","Partner in crime","Knows my secrets","Stubborn","Always right","Steals my clothes","Never texts back","Competitive","Total chaos","Started every fight","Covered for me","Calls at odd hours","Remembers it all","A bad influence","Always loudest","Beat me at everything","Steals my food","Knows me too well","Softer than they look","Makes me cry laughing","Copies my haircut","Never lost a game","Would fight for me"],
      FRIEND:["Loyal","Funny","Kind","Generous","Always there","Genuine","Big-hearted","Easy to talk to","Thoughtful","Warm","Honest","Fun","Dependable","One in a million","Always shows up","Always late","Brutally honest","Answers at 3am","Never judges","Remembers it all","Up for anything","Feeds everyone","Terrible dancer","Loud","Quietly steady","Competitive","Good bad influence","Sends the memes","First one there","Last to leave","Cries at films","Best advice","Plans nothing","Terrible at goodbyes","Knows me too well","Never forgets a birthday"],
      SELF:["Kind","Strong","Loyal","Funny","Hopeful","Honest","Caring","Determined","Generous","Patient","Grateful","Resilient","Loving","Enough","Stubborn","Still learning","Restless","Tired but trying","A dreamer","A fighter","Soft-hearted","Too honest","Overthinks","Never gives up","Quiet","Curious","Bad at asking help","Always planning","Kinder than I was","Learning to rest","Hard on myself","Getting there","Says yes too often","Better than I was","Not finished yet","Proud of myself"],
      GENERAL:["Kind","Funny","Generous","Loving","Loyal","Patient","Strong","Big-hearted","Thoughtful","Gentle","Honest","Warm","Genuine","Selfless","Stubborn","Fearless","Always early","Feeds everyone","Never sits still","Brutally honest","Quietly strong","Wickedly funny","Terrible dancer","Remembers it all","Never complains","Fixes everything","Tells long stories","Up for anything","Always busy","Good in a crisis","Sings badly","Best advice","Never forgets a birthday","Makes everyone welcome","Laughs at everything","Bad at sitting down"]
    };
    function traitsFor(rel) {
      if (has(SPOUSE, rel)) return TRAITS.ROMANTIC;
      if (has(PARENT, rel)) return TRAITS.PARENT;
      if (has(GRAND, rel)) return TRAITS.GRAND;
      if (has(KID, rel)) return TRAITS.KID;
      if (rel === "Sibling") return TRAITS.SIBLING;
      if (rel === "Friend") return TRAITS.FRIEND;
      if (rel === "Myself") return TRAITS.SELF;
      return TRAITS.GENERAL;
    }
    var PHASES = {
      1:{ name:"About them", caption:"A few quick details" },
      2:{ name:"About them", caption:"Make it personal" },
      3:{ name:"About them", caption:"One more thing" },
      4:{ name:"The sound", caption:"Shape the music" },
      5:{ name:"Their story", caption:"This makes the song theirs" },
      6:{ name:"Their story", caption:"Anything you want in the song" },
      7:{ name:"Ready", caption:"One quick check" }
    };

    function escq(s) { return String(s).replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/"/g,"&quot;"); }

    function wire(root) {
      if (root.__sbqWired) return;
      root.__sbqWired = true;
      root.__sbWired = true; // defense: keeps song-brief's wiring off this root if both snippets ever share a page

      var S = { screen:1, rel:"", relOther:"", name:"", pron:"", pronOpen:false, nudgeDismissed:false,
        occ:"", occOther:false, style:"", mood:"", voice:"", soundOpen:"style", traits:[], custom:[], story:"", ex:false, inst:false };

      // Host (main-custom-song's .cs) — hidden buy rail is the cart engine; the quiz
      // mirrors add-on choices into it and its summary screen shows the money.
      var hostCs = root.closest(".cs");
      var P = hostCs ? {
        base: parseInt(hostCs.getAttribute("data-base-cents"), 10) || 0,
        ex: parseInt(hostCs.getAttribute("data-ex-cents"), 10) || 0,
        inst: parseInt(hostCs.getAttribute("data-in-cents"), 10) || 0
      } : null;
      function money(c) { return "$" + (c / 100).toFixed(2); }
      function totalCents() { return P ? P.base + (S.ex ? P.ex : 0) + (S.inst ? P.inst : 0) : 0; }
      function syncHostAddons() {
        if (!hostCs) return;
        [["ex", S.ex], ["in", S.inst]].forEach(function (pair) {
          var cb = hostCs.querySelector('[data-add="' + pair[0] + '"]');
          if (cb && cb.checked !== pair[1]) { cb.checked = pair[1]; try { cb.dispatchEvent(new Event("change")); } catch (e) {} }
        });
      }
      var STORE_KEY = "sbq_draft";
      try {
        var saved = JSON.parse(sessionStorage.getItem(STORE_KEY) || "null");
        if (saved && typeof saved === "object") {
          ["rel","relOther","name","pron","occ","style","mood","voice","story"].forEach(function (k) { if (typeof saved[k] === "string") S[k] = saved[k]; });
          if (Array.isArray(saved.traits)) S.traits = saved.traits.slice(0, 40);
          if (Array.isArray(saved.custom)) S.custom = saved.custom.slice(0, 40);
          S.ex = !!saved.ex; S.inst = !!saved.inst;
          S.occOther = !!S.occ && ALL_OCCASIONS.indexOf(S.occ) === -1;
          // resume at the first unanswered screen (funnel behavior)
          S.screen = !S.rel ? 1 : !S.name ? 2 : !S.occ ? 3 : !(S.style && S.mood && S.voice) ? 4 : (S.traits.length + S.custom.length === 0) ? 5 : 7;
          if (S.screen === 4) S.soundOpen = !S.style ? "style" : !S.mood ? "mood" : "voice";
        }
      } catch (e) {}
      function persist() {
        try { sessionStorage.setItem(STORE_KEY, JSON.stringify({ rel:S.rel, relOther:S.relOther, name:S.name, pron:S.pron, occ:S.occ, style:S.style, mood:S.mood, voice:S.voice, traits:S.traits, custom:S.custom, story:S.story, ex:S.ex, inst:S.inst })); } catch (e) {}
      }
      function relValue() { return S.rel === "Someone else" ? S.relOther.trim() : S.rel; }

      var head = root.querySelector('[data-sbq-head]');
      var backBtn = root.querySelector('[data-sbq-back]');
      var countEl = root.querySelector('[data-sbq-count]');
      var phaseEl = root.querySelector('[data-sbq-phase]');
      var captionEl = root.querySelector('[data-sbq-caption]');
      var barWrap = root.querySelector('[data-sbq-barwrap]');
      var barEl = root.querySelector('[data-sbq-bar]');
      var screenEl = root.querySelector('[data-sbq-screen]');
      var voiceBox = root.querySelector('[data-voice]');
      var foot = root.querySelector('[data-sbq-foot]');
      var nextBtn = root.querySelector('[data-sbq-next]');
      var underEl = root.querySelector('[data-sbq-under]');
      var advanceTimer = null;

      function setChrome(n) {
        var total = 6, ph = PHASES[n];
        var pct = Math.round((n / (total + 1)) * 100);
        head.hidden = false;
        // Step 1 has no back — the breadcrumb's Home is the only exit (founder).
        backBtn.disabled = (n === 1);
        countEl.textContent = "Step " + Math.min(n, total) + " of " + total + " · " + pct + "%";
        phaseEl.textContent = ph.name;
        captionEl.textContent = ph.caption;
        barWrap.setAttribute("aria-valuenow", String(pct));
        barEl.style.width = pct + "%";
      }
      function setFoot(label, enabled, under) {
        foot.hidden = false;
        nextBtn.textContent = label;
        nextBtn.disabled = !enabled;
        underEl.textContent = under || "";
      }
      function chips(list, selected, act, small, pm) {
        var h = '<div class="sbq-chips">';
        list.forEach(function (c) {
          var on = pm ? (selected.indexOf(c) !== -1) : (selected === c);
          h += '<button type="button" class="sbq-chip' + (small ? " sbq-chip--sm" : "") + (on ? " on" : "") + '" data-a="' + act + '" data-v="' + escq(c) + '"' + (pm ? ' aria-pressed="' + on + '"' : "") + '>' + (pm ? '<span class="sbq-pm">' + (on ? "✓" : "+") + "</span>" : "") + escq(c) + "</button>";
        });
        return h + "</div>";
      }

      function render() {
        if (advanceTimer) { clearTimeout(advanceTimer); advanceTimer = null; }
        voiceBox.hidden = (S.screen !== 6);
        var h = "";
        if (S.screen === 1) {
          setChrome(1);
          h = '<h3 class="sbq-title">Who’s this song for?</h3><p class="sbq-sub">Pick the person you’re making it for.</p>'
            + chips(REL_ALL, S.rel, "rel", false, false);
          if (S.rel === "Someone else") {
            h += '<div style="margin-top:12px"><input class="sbq-in" data-f="relOther" maxlength="40" placeholder="Coach, mentor, teammate…" value="' + escq(S.relOther) + '" autocapitalize="words" aria-label="Who are they to you?"><p class="sbq-fnote">In your words — it shapes how the song calls them.</p></div>';
            setFoot("Continue →", S.relOther.trim().length >= 2, "A word or two is plenty — Coach, Mentor, Best man…");
          } else {
            setFoot("Continue →", !!S.rel, "You can change this later.");
          }
        } else if (S.screen === 2) {
          setChrome(2);
          var cfg = callNameConfig(S.rel);
          h = '<h3 class="sbq-title">' + escq(cfg.title) + '</h3><p class="sbq-sub">' + escq(cfg.sub) + "</p>";
          if (cfg.quick.length) h += '<p class="sbq-flabel">Quick picks</p><div style="margin-bottom:11px">' + chips(cfg.quick, S.name, "quick", true, false) + "</div>";
          h += '<input class="sbq-in" data-f="name" placeholder="' + escq(cfg.ph) + '" value="' + escq(S.name) + '" autocapitalize="words"><p class="sbq-fnote">This is the name the song sings.</p>';
          var alts = familyAlternatives(S.rel);
          if (alts.length && looksLikeFirstName(S.name) && !S.nudgeDismissed) {
            h += '<div class="sbq-nudge" role="status"><p>Prefer a family name in the song?</p><div class="sbq-chips">';
            alts.forEach(function (a) { h += '<button type="button" class="sbq-chip sbq-chip--sm" data-a="quick" data-v="' + escq(a) + '">' + escq(a) + "</button>"; });
            h += '<button type="button" class="sbq-chip sbq-chip--sm" data-a="keepname">Keep ' + escq(S.name.trim()) + "</button></div></div>";
          }
          h += S.pronOpen
            ? '<div style="margin-top:11px"><input class="sbq-in" data-f="pron" placeholder="e.g. Joaquin → wah-KEEN" value="' + escq(S.pron) + '"><p class="sbq-fnote">Written how you say it — only if it could be unclear.</p></div>'
            : '<button type="button" class="sbq-link" data-a="pron">Add pronunciation</button>';
          setFoot("Continue →", !!S.name.trim(), "");
        } else if (S.screen === 3) {
          setChrome(3);
          var lead = occasionOrder(S.rel);
          var list = lead.slice();
          ALL_OCCASIONS.forEach(function (o) { if (list.indexOf(o) === -1) list.push(o); });
          list.push(OCC_OTHER);
          var sel = S.occOther ? OCC_OTHER : S.occ;
          h = '<h3 class="sbq-title">What’s the occasion?</h3><p class="sbq-sub">So the song celebrates the right thing.</p>' + chips(list, sel, "occ", false, false);
          if (S.occOther) {
            h += '<div style="margin-top:12px"><input class="sbq-in" data-f="occCustom" placeholder="e.g. Engagement party, Homecoming, New Job" aria-label="Your occasion" value="' + escq(ALL_OCCASIONS.indexOf(S.occ) === -1 ? S.occ : "") + '"></div>';
            setFoot("Continue →", !!S.occ.trim(), "");
          } else {
            setFoot("Continue →", !!S.occ, "");
          }
        } else if (S.screen === 4) {
          setChrome(4);
          var styles = recommendedStyles(S.rel, S.occ).slice();
          ALL_STYLES.forEach(function (s) { if (styles.indexOf(s) === -1) styles.push(s); });
          styles.push(SURPRISE);
          var moods = moodOptions(S.rel, S.occ).concat([SURPRISE]);
          h = '<h3 class="sbq-title">Music style, voice and mood</h3>';
          var grp = function (key, label, list, val) {
            if (S.soundOpen === key) return '<div class="sbq-grp">' + (label ? '<p class="sbq-glabel">' + label + "</p>" : "") + chips(list, val, "snd:" + key, true, false) + "</div>";
            if (val) return '<div class="sbq-grp"><div class="sbq-grow"><span class="sbq-gname">' + (label || "Style") + '</span><span class="sbq-gval">' + escq(val) + '</span><button type="button" class="sbq-gchange" data-a="sndopen" data-v="' + key + '">Change</button></div></div>';
            return '<div class="sbq-grp"><div class="sbq-grow"><span class="sbq-gname">' + (label || "Style") + '</span><span class="sbq-gval sbq-gval--empty">—</span></div></div>';
          };
          h += grp("style", "", styles, S.style) + grp("mood", "Feeling", moods, S.mood) + grp("voice", "Voice", VOICES, S.voice);
          setFoot("Continue →", !!(S.style && S.mood && S.voice), "Can’t decide? Surprise Me picks what fits the story.");
        } else if (S.screen === 5) {
          setChrome(5);
          h = '<h3 class="sbq-title" style="margin-bottom:12px">What are they like?</h3>'
            + chips(traitsFor(S.rel), S.traits, "trait", true, true)
            + '<p class="sbq-flabel">Something else</p><div class="sbq-addrow"><input class="sbq-in" data-f="custom" maxlength="60" placeholder="In your own words"><button type="button" class="sbq-addbtn" data-a="addcustom">Add</button></div>';
          if (S.custom.length) {
            h += '<div class="sbq-added">';
            S.custom.forEach(function (c, i) { h += '<span class="sbq-pill">' + escq(c) + '<button type="button" data-a="rmcustom" data-v="' + i + '" aria-label="Remove ' + escq(c) + '">×</button></span>'; });
            h += "</div>";
          }
          setFoot("Continue →", S.traits.length + S.custom.length > 0, "");
        } else if (S.screen === 6) {
          setChrome(6);
          h = '<h3 class="sbq-title">Anything else the song should know?</h3><p class="sbq-sub">A story, a favourite memory, an inside joke, something it must say.</p><p class="sbq-hint">Optional — but one real detail is what makes it theirs.</p>'
            + '<p class="sbq-flabel">In your own words</p><textarea class="sbq-ta" data-f="story" rows="6" placeholder="How you met, a moment you both remember, a phrase only they say, something you’ve never told them…">' + escq(S.story) + "</textarea>";
          var hasDetail = S.story.replace(/[.…,;:!?\s]+/g, "").length >= 3;
          setFoot(S.story.trim() ? "Continue →" : "Skip →", true, hasDetail ? "Perfect — that’s what makes it theirs." : "Optional — one real detail makes it more theirs.");
        } else {
          setChrome(7);
          var name = S.name.trim() || "Their";
          var poss = /s$/i.test(name) ? name + "’" : name + "’s";
          var row = function (l, v, s) { return '<div class="sbq-rrow"><span class="sbq-rl">' + l + '</span><span class="sbq-rv">' + (v ? escq(v) : "—") + '<button type="button" class="sbq-redit" data-a="edit" data-v="' + s + '">Edit</button></span></div>'; };
          h = '<h3 class="sbq-title">' + escq(poss) + ' song is ready to be written.</h3><p class="sbq-sub">One quick check — pick your delivery and create it.</p>'
            + row("For", relValue(), 1) + row("Name", S.name, 2) + row("Occasion", S.occ, 3)
            + row("Style", S.style, 4) + row("Feeling", S.mood, 4) + row("Voice", S.voice, 4)
            + row("What they’re like", S.traits.concat(S.custom).join(", "), 5)
            + row("In your own words", S.story ? S.story.split(/\s+/).slice(0, 5).join(" ") + "…" : "", 6);
          if (P) {
            h += '<div class="sbq-addons">'
              + '<label class="sbq-addon"><span class="sbq-atext"><b>Express delivery<span class="sbq-pop">Most popular</span></b><small>3–6 hour delivery</small></span><span class="sbq-aright"><span class="sbq-aprice">+' + money(P.ex) + '</span><input type="checkbox" data-f="ex"' + (S.ex ? " checked" : "") + '></span></label>'
              + '<label class="sbq-addon"><span class="sbq-atext"><b>Instrumental version</b><small>The melody without vocals</small></span><span class="sbq-aright"><span class="sbq-aprice">+' + money(P.inst) + '</span><input type="checkbox" data-f="inst"' + (S.inst ? " checked" : "") + '></span></label>'
              + '</div>'
              + '<div class="sbq-totalrow"><span>Total</span><span>' + money(totalCents()) + "</span></div>";
          }
          foot.hidden = false;
          nextBtn.textContent = "Create My Song" + (P ? " · " + money(totalCents()) : " →");
          nextBtn.disabled = false;
          underEl.textContent = "Secure checkout · Delivered within 24 hours · Unlimited revisions";
        }
        // Funnel rule (founder 2026-08-19): nothing on screen but the quiz, on
        // EVERY screen including the summary. .sbq-focus is set pre-paint by the
        // inline script in the markup and is never removed.
        screenEl.innerHTML = h;
        wireScreen();
        persist();
      }

      function advance(delay) {
        if (advanceTimer) clearTimeout(advanceTimer);
        advanceTimer = setTimeout(function () {
          advanceTimer = null;
          S.screen = Math.min(S.screen + 1, 7);
          render();
          try { root.scrollIntoView({ block: "start", behavior: "smooth" }); } catch (e) {}
        }, delay || 0);
      }

      function wireScreen() {
        screenEl.querySelectorAll("[data-a]").forEach(function (el) {
          el.addEventListener("click", function () {
            var a = el.getAttribute("data-a"), v = el.getAttribute("data-v");
            if (a === "edit") { S.screen = parseInt(v, 10) || 1; if (S.screen === 4) S.soundOpen = "style"; render(); return; }
            if (a === "rel") {
              S.rel = v;
              // relationship change can invalidate the mood list downstream
              if (S.mood && moodOptions(S.rel, S.occ).indexOf(S.mood) === -1) S.mood = "";
              if (v === "Someone else") { render(); var f = screenEl.querySelector('[data-f="relOther"]'); if (f) f.focus(); }
              else { render(); advance(180); }
              return;
            }
            if (a === "quick") { S.name = v; S.nudgeDismissed = true; render(); return; }
            if (a === "keepname") { S.nudgeDismissed = true; render(); return; }
            if (a === "pron") { S.pronOpen = true; render(); var p = screenEl.querySelector('[data-f="pron"]'); if (p) p.focus(); return; }
            if (a === "occ") {
              if (v === OCC_OTHER) { S.occOther = true; S.occ = ""; render(); var o = screenEl.querySelector('[data-f="occCustom"]'); if (o) o.focus(); }
              else { S.occOther = false; S.occ = v; if (S.mood && moodOptions(S.rel, v).indexOf(S.mood) === -1) S.mood = ""; render(); advance(180); }
              return;
            }
            if (a && a.indexOf("snd:") === 0) {
              var k = a.slice(4);
              if (k === "style") S.style = (v === SURPRISE) ? recommendedStyles(S.rel, S.occ)[0] : v;
              else if (k === "mood") S.mood = (v === SURPRISE) ? moodOptions(S.rel, S.occ)[0] : v;
              else S.voice = v; // "Surprise Me" is a real voice answer → No preference at collect
              S.soundOpen = !S.style ? "style" : !S.mood ? "mood" : !S.voice ? "voice" : "";
              render();
              if (S.style && S.mood && S.voice) advance(220);
              return;
            }
            if (a === "sndopen") { S.soundOpen = v; render(); return; }
            if (a === "trait") {
              var i = S.traits.indexOf(v);
              if (i === -1) { if (S.traits.length < 40) S.traits.push(v); } else S.traits.splice(i, 1);
              render(); return;
            }
            if (a === "addcustom") {
              var f2 = screenEl.querySelector('[data-f="custom"]');
              var t = ((f2 && f2.value) || "").trim().replace(/\s+/g, " ").slice(0, 60);
              var dup = S.custom.some(function (x) { return x.toLowerCase() === t.toLowerCase(); });
              if (t && !dup && S.custom.length < 40) S.custom.push(t);
              render();
              var g = screenEl.querySelector('[data-f="custom"]'); if (g) g.focus();
              return;
            }
            if (a === "rmcustom") { S.custom.splice(parseInt(v, 10), 1); render(); return; }
          });
        });
        screenEl.querySelectorAll('input[type="checkbox"][data-f]').forEach(function (cb) {
          cb.addEventListener("change", function () {
            if (cb.getAttribute("data-f") === "ex") S.ex = cb.checked; else S.inst = cb.checked;
            syncHostAddons();
            render();
          });
        });
        screenEl.querySelectorAll('input[data-f]:not([type="checkbox"]),textarea[data-f]').forEach(function (f) {
          f.addEventListener("input", function () {
            var k = f.getAttribute("data-f");
            if (k === "relOther") { S.relOther = f.value; nextBtn.disabled = S.relOther.trim().length < 2; }
            else if (k === "name") {
              S.name = f.value; nextBtn.disabled = !S.name.trim();
              var alts = familyAlternatives(S.rel);
              var showing = !!screenEl.querySelector(".sbq-nudge");
              var should = alts.length > 0 && looksLikeFirstName(S.name) && !S.nudgeDismissed;
              if (showing !== should) {
                var pos = f.selectionStart;
                render();
                var g2 = screenEl.querySelector('[data-f="name"]');
                if (g2) { g2.focus(); try { g2.setSelectionRange(pos, pos); } catch (e) {} }
              }
            }
            else if (k === "pron") { S.pron = f.value; }
            else if (k === "occCustom") { S.occ = f.value; nextBtn.disabled = !S.occ.trim(); }
            else if (k === "story") {
              S.story = f.value;
              nextBtn.textContent = S.story.trim() ? "Continue →" : "Skip →";
              underEl.textContent = S.story.replace(/[.…,;:!?\s]+/g, "").length >= 3 ? "Perfect — that’s what makes it theirs." : "Optional — one real detail makes it more theirs.";
            }
            persist();
          });
          if (f.getAttribute("data-f") === "custom") {
            f.addEventListener("keydown", function (e) {
              if (e.key === "Enter") { e.preventDefault(); var b = screenEl.querySelector('[data-a="addcustom"]'); if (b) b.click(); }
            });
          }
        });
      }

      backBtn.addEventListener("click", function () {
        if (S.screen > 1) { S.screen--; if (S.screen === 4) S.soundOpen = "style"; render(); }
      });
      var submitting = false;
      var errEl = root.querySelector("[data-error]");
      if (errEl && "MutationObserver" in window) {
        // The host's showErr unhides this element on any failure — that's our
        // signal to re-arm the CTA after a cart error.
        new MutationObserver(function () {
          if (!errEl.hidden && submitting) { submitting = false; render(); }
        }).observe(errEl, { attributes: true, attributeFilter: ["hidden"] });
      }
      nextBtn.addEventListener("click", function () {
        if (S.screen < 7) { advance(0); return; }
        if (submitting) return;
        // Summary CTA — mirror the add-on choices into the hidden rail, then hand
        // off to the host section's add-to-cart button (it validates via sbBrief,
        // posts /cart/add.js with properties + voice, adds add-ons, → /checkout).
        syncHostAddons();
        var submit = hostCs ? hostCs.querySelector("[data-submit]") : null;
        if (submit) {
          submitting = true;
          nextBtn.disabled = true;
          nextBtn.textContent = "Adding…";
          if (errEl) errEl.hidden = true;
          submit.click();
        }
      });
      syncHostAddons();

      // voice note: attach + record (ported from song-brief)
      var voiceBlob = null, voiceName = null;
      var vfile = root.querySelector("[data-vfile]"), vstatus = root.querySelector("[data-vstatus]");
      var vrec = root.querySelector("[data-vrec]");
      function setStatus(txt, cls) { if (!vstatus) return; vstatus.textContent = txt; vstatus.className = "sbq-vstatus" + (cls ? " " + cls : ""); }
      if (vfile) vfile.addEventListener("change", function () { if (vfile.files && vfile.files[0]) { voiceBlob = vfile.files[0]; voiceName = vfile.files[0].name; setStatus("✓ Attached: " + voiceName, "is-on"); } });
      var canRec = !!(navigator.mediaDevices && navigator.mediaDevices.getUserMedia && window.MediaRecorder);
      if (vrec && canRec) {
        vrec.hidden = false;
        var mr = null, chunks = [], recState = "idle", secs = 0, timer = null, stream = null;
        var recLabel = root.querySelector("[data-vrec-label]");
        var fmt = function (s) { return Math.floor(s / 60) + ":" + (s % 60 < 10 ? "0" : "") + (s % 60); };
        vrec.addEventListener("click", function () {
          if (recState === "idle") {
            navigator.mediaDevices.getUserMedia({ audio: true }).then(function (s) {
              stream = s; chunks = []; mr = new MediaRecorder(s);
              mr.ondataavailable = function (e) { if (e.data && e.data.size) chunks.push(e.data); };
              mr.onstop = function () { voiceBlob = new Blob(chunks, { type: (mr.mimeType || "audio/webm") }); voiceName = "voice-note.webm"; if (stream) { stream.getTracks().forEach(function (t) { t.stop(); }); } setStatus("✓ Voice note recorded · " + fmt(secs), "is-on"); };
              mr.start(); recState = "rec"; secs = 0; voiceBox.setAttribute("data-state", "rec"); if (recLabel) recLabel.textContent = "Stop"; setStatus("● Recording 0:00", "is-rec");
              timer = setInterval(function () { secs++; setStatus("● Recording " + fmt(secs), "is-rec"); }, 1000);
            }).catch(function () { setStatus("Mic unavailable — attach a file instead", ""); });
          } else if (recState === "rec") {
            recState = "idle"; if (timer) clearInterval(timer); voiceBox.setAttribute("data-state", "idle"); if (recLabel) recLabel.textContent = "Re-record"; try { mr.stop(); } catch (e) {}
          }
        });
      }

      // Host API — same shape as song-brief's.
      root.sbBrief = {
        validate: function () {
          var goTo = 0, msg = "";
          if (!S.rel || (S.rel === "Someone else" && S.relOther.trim().length < 2)) { goTo = 1; msg = "Tell us who the song is for."; }
          else if (!S.name.trim()) { goTo = 2; msg = "Add the name the song should sing."; }
          else if (!S.occ.trim()) { goTo = 3; msg = "Pick the occasion."; }
          else if (!(S.style && S.mood && S.voice)) { goTo = 4; msg = "Pick the style, feeling and voice."; }
          else if (S.traits.length + S.custom.length === 0) { goTo = 5; msg = "Tap at least one thing they’re like."; }
          if (goTo) {
            S.screen = goTo;
            if (goTo === 4) S.soundOpen = !S.style ? "style" : !S.mood ? "mood" : "voice";
            render();
            try { root.scrollIntoView({ block: "start", behavior: "smooth" }); } catch (e) {}
            return msg;
          }
          return "";
        },
        collect: function () {
          var props = {};
          props["Recipient Name"] = S.name.trim();
          var rv = relValue(); if (rv && rv !== "Myself") props["Relationship"] = rv;
          else if (rv === "Myself") props["Relationship"] = "Myself";
          props["Occasion"] = S.occ.trim();
          props["Genre"] = S.style;
          props["Mood"] = S.mood;
          props["Singer Preference"] = S.voice === "Female voice" ? "Female" : S.voice === "Male voice" ? "Male" : "No preference";
          // Story: quiz2's assembleStory format — traits line, free text, pronunciation.
          var blocks = [];
          var allTraits = S.traits.concat(S.custom);
          if (allTraits.length) blocks.push("What they’re like: " + allTraits.join(", "));
          if (S.story.trim()) blocks.push(S.story.trim());
          var pron = S.pron.trim();
          if (pron) blocks.push((S.name.trim() || "The name") + ' is pronounced "' + pron + '" — spell it that way where it is sung if it helps the singer.');
          if (blocks.length) props["Story"] = blocks.join("\n\n");
          return props;
        },
        getVoice: function () { return voiceBlob ? { blob: voiceBlob, name: voiceName || "voice-note.webm" } : null; }
      };

      render();
    }

    function initAll() { document.querySelectorAll("[data-song-quiz]").forEach(wire); }
    if (document.readyState !== "loading") initAll();
    else document.addEventListener("DOMContentLoaded", initAll);
    window.sbQuizInit = initAll;
  })();
  } catch(e) { console.error(e); }
})();

})();
